module.exports = __webpack_public_path__ + "static/img/智能报账4.46061995.png";